import { render, staticRenderFns } from "./MedCompanies.vue?vue&type=template&id=6b2a264d&scoped=true&"
import script from "./MedCompanies.vue?vue&type=script&lang=js&"
export * from "./MedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./MedCompanies.vue?vue&type=style&index=0&id=6b2a264d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a264d",
  null
  
)

export default component.exports